import { createAction } from 'redux-actions';

import { SEND_PASSWORD, SEND_PASSWORD_FINISHED } from './constants';

// Change forgotten password outside MunMoi
export const sendPassword = createAction(SEND_PASSWORD, (token, password) => ({
	token,
	password
}));

export const sendPasswordFinished = createAction(SEND_PASSWORD_FINISHED, () => ({}));
